import React from 'react';
import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, Typography, useMediaQuery } from '@mui/material';
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator, timelineOppositeContentClasses } from '@mui/lab';
import { workExperience } from '../../data/workExperience';
import { timelineExperience } from '../../data/timelineExperience';


const Experience = () => {
    const [showKnowMoreDialog, setShowKnowMoreDialog] = React.useState(false);
    const [knowMoreDialogTitle, setKnowMoreDialogTitle] = React.useState("");
    const [currentCompanyName, setCurrentCompanyName] = React.useState();
    // const theme = useTheme();
    const maxWidthTimelineMediaQuery = useMediaQuery('(max-width:620px)');


    const renderKnowMoreDialog = () => {
        // console.log("currentCompanyName", currentCompanyName);
        // console.log(workExperience[currentCompanyName]);
        let companyClients = workExperience[currentCompanyName];

        return (
            <Dialog
                open={showKnowMoreDialog}
                onClose={() => setShowKnowMoreDialog(false)}
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle align='center'>
                    {knowMoreDialogTitle}
                </DialogTitle>
                <DialogContent dividers>
                    {/* <DialogContentText> */}
                    {
                        Object.keys(companyClients).map((clientName, index1) => {
                            // console.log(clientName);
                            // console.log(companyClients[clientName]);
                            let responsibilities = companyClients[clientName];
                            return (
                                <React.Fragment key={index1}>
                                    <Typography variant="h6" component="div">
                                        Client: {clientName}
                                    </Typography>
                                    <ul>
                                        {
                                            responsibilities.map((responsibility, index2) => {
                                                return (
                                                    <li key={index2}>{responsibility}</li>
                                                )
                                            })
                                        }
                                    </ul>
                                </React.Fragment>
                            )
                        })
                    }
                    {/* </DialogContentText> */}
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        autoFocus
                        onClick={() => setShowKnowMoreDialog(false)}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        )
    };

    const handleKnowMoreBtnClick = (dialogTitle) => {
        setCurrentCompanyName(dialogTitle);
        setKnowMoreDialogTitle(`${dialogTitle} Work Experience`);
        setShowKnowMoreDialog(true);
    };

    return (
        <>
            {showKnowMoreDialog && renderKnowMoreDialog()}
            <Card variant="outlined">
                <CardContent>
                    <Timeline sx={{
                        [`& .${timelineOppositeContentClasses.root}`]: {
                            flex: 0.2,
                        },
                    }}>
                        {
                            timelineExperience.map((company, index) => {
                                return (
                                    <TimelineItem key={index} sx={{
                                        '&:before': {
                                            display: 'none'
                                        }
                                    }}>
                                        {
                                            !maxWidthTimelineMediaQuery && (
                                                <TimelineOppositeContent>
                                                    {company.experienceYearRange}
                                                </TimelineOppositeContent>
                                            )
                                        }
                                        <TimelineSeparator>
                                            <TimelineDot />
                                            {index !== timelineExperience.length - 1 && <TimelineConnector />}
                                        </TimelineSeparator>
                                        <TimelineContent>
                                            <Card>
                                                <CardContent>
                                                    <Typography variant="h6" component="div">
                                                        {company.name}
                                                    </Typography>
                                                    {
                                                        maxWidthTimelineMediaQuery && (
                                                            <div>{company.experienceYearRange}</div>
                                                        )
                                                    }
                                                    <div>{company.role}</div>
                                                    <Button
                                                        onClick={() => handleKnowMoreBtnClick(company.name)}
                                                        sx={{
                                                            border: 'none !important',
                                                            outline: 'none !important',
                                                            color: 'cornflowerblue',
                                                            background: 'none',
                                                            padding: '0',
                                                            textTransform: 'inherit'
                                                        }}
                                                    >
                                                        Know More
                                                    </Button>
                                                </CardContent>
                                            </Card>
                                        </TimelineContent>
                                    </TimelineItem>
                                )
                            })
                        }
                    </Timeline>
                </CardContent>
            </Card>
            {/* <Card variant="outlined">
                <CardContent>
                    <Timeline sx={{
                        [`& .${timelineOppositeContentClasses.root}`]: {
                            flex: 0.2,
                        },
                    }}>
                        <TimelineItem sx={{
                            '&:before': {
                                display: 'none'
                            }
                        }}>
                            {
                                !maxWidthTimelineMediaQuery && (
                                    <TimelineOppositeContent>
                                        2021-Present
                                    </TimelineOppositeContent>
                                )
                            }
                            <TimelineSeparator>
                                <TimelineDot />
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent
                            // className="timelineCard"
                            // sx={{
                            //     position: 'relative',
                            //     '&:before': {
                            //         content: '" "',
                            //         height: '0',
                            //         position: 'absolute',
                            //         top: '8px',
                            //         width: '0',
                            //         zIndex: '1',
                            //         left: '5px',
                            //         border: `medium solid ${theme.palette.background.paper}`,
                            //         borderWidth: '10px 10px 10px 0',
                            //         borderColor: `transparent ${theme.palette.background.paper} transparent transparent`,
                            //     }
                            // }}
                            >
                                <Card>
                                    <CardContent>
                                        <Typography variant="h6" component="div">
                                            Accenture
                                        </Typography>
                                        {
                                            maxWidthTimelineMediaQuery && (
                                                <div>2021-Present</div>
                                            )
                                        }
                                        <div>Frontend developer</div>
                                        <Button
                                            onClick={() => handleKnowMoreBtnClick('Accenture')}
                                            sx={{
                                                border: 'none !important',
                                                outline: 'none !important',
                                                color: 'cornflowerblue',
                                                background: 'none',
                                                padding: '0',
                                                textTransform: 'inherit'
                                            }}
                                        >
                                            Know More
                                        </Button>
                                    </CardContent>
                                </Card>
                            </TimelineContent>
                        </TimelineItem>
                        <TimelineItem sx={{
                            '&:before': {
                                display: 'none'
                            }
                        }}>
                            {
                                !maxWidthTimelineMediaQuery && (
                                    <TimelineOppositeContent>
                                        2018-2021
                                    </TimelineOppositeContent>
                                )
                            }
                            <TimelineSeparator>
                                <TimelineDot />
                            </TimelineSeparator>
                            <TimelineContent>
                                <Card>
                                    <CardContent>
                                        <Typography variant="h6" component="div">
                                            Tata Consultancy Services(TCS)
                                        </Typography>
                                        {
                                            maxWidthTimelineMediaQuery && (
                                                <div>2018-2021</div>
                                            )
                                        }
                                        <div>Frontend developer</div>
                                        <Button
                                            onClick={() => handleKnowMoreBtnClick('Tata Consultancy Services (TCS)')}
                                            sx={{
                                                border: 'none !important',
                                                outline: 'none !important',
                                                color: 'cornflowerblue',
                                                background: 'none',
                                                padding: '0',
                                                textTransform: 'inherit'
                                            }}
                                        >
                                            Know More
                                        </Button>
                                    </CardContent>
                                </Card>
                            </TimelineContent>
                        </TimelineItem>
                    </Timeline>
                </CardContent>
            </Card> */}
        </>
    )
}

export default Experience
